const States = {
  AL: "Alabama",
  AK: "Alaska",
  // "AS": "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  // "FM": "Federated States Of Micronesia",
  FL: "Florida",
  GA: "Georgia",
  // "GU": "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  // "MH": "Marshall Islands",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  // "MP": "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  // "PW": "Palau",
  PA: "Pennsylvania",
  // "PR": "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  // "VI": "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const SecurityType = {
  AirportSeaportRevenues: "Airport/Seaport Revenues",
  CharterSchool: "Charter School",
  DoubleBarrelRevenue: "Double Barrel Revenue",
  ElectricRevenues: "Electric Revenues",
  HospitalRevenues: "Hospital Revenues",
  HousingRevenues: "Housing Revenues",
  HotelRevenues: "Hotel Revenues",
  LeaseRent: "Lease/Rent",
  LimitedTaxGeneralObligation: "Limited Tax General Obligation",
  LoanAgreement: "Loan Agreement",
  MunicipalUtilityDistrict: "Municipal Utility District",
  OtherRevenue: "Other Revenue",
  PrivateHigherEducation: "Private Higher Education",
  PublicHigherEducation: "Public Higher Education",
  SalesExciseTax: "Sales/Excise Tax",
  SeniorLiving: "Senior Living",
  SpecialAssessments: "Special Assessments",
  SpecialTax: "Special Tax",
  TaxIncrementRevenues: "Tax Increment Revenues",
  TobaccoSettlement: "Tobacco Settlement",
  TransportationRevenues: "Transportation Revenues",
  UnlimitedTaxGeneralObligation: "Unlimited Tax General Obligation",
  UtilityRevenue: "Utility Revenue"
};

const RatingAssumption = {
  AAA: "AAA",
  AAPlus: "AA+",
  AA: "AA",
  AAMinus: "AA-",
  APlus: "A+",
  A: "A",
  AMinus: "A-",
  BBBPlus: "BBB+",
  BBB: "BBB",
  BBBMinus: "BBB-",
};

const ExpandedRatingOptions = {
  AAA: "AAA",
  AAPlus: "AA+",
  AA: "AA",
  AAMinus: "AA-",
  APlus: "A+",
  A: "A",
  AMinus: "A-",
  BBBPlus: "BBB+",
  BBB: "BBB",
  BBBMinus: "BBB-",
  BBPlus: "BB+",
  BB: "BB",
  BBMinus: "BB-",
};

const TaxDesignation = {
  BankQualified: "Bank Qualified",
  NonBankQualified: "Non-Bank Qualified",
  SubjectToAMT: "Subject to AMT",
  Taxable: "Taxable",
};

const PrincipalRate = {
  Annual: "Annual",
  SemiAnnual: "Semi-Annual",
};

const BondSolutions = ["Size by Par"];

const CallPriceDefault = 100.0;

const CouponSelection = {
  FiCurveCouponPrediction: "Spline Coupon Prediction",
  FivePercentCoupon: "5% Coupon",
};

const SaleMethod = {
  Negotiated: "Negotiated",
  Competitive: "Competitive",
};

function getStateAbbreviation(stateName) {
  for (let key in States) {
    if (States[key] === stateName) {
      return key;
    }
  }
  return null; // Return null if no match is found
}

export function taxDesignationToCode(designation) {
  switch (designation) {
    case TaxDesignation.BankQualified:
    case TaxDesignation.NonBankQualified:
      return "EXMP";
    case TaxDesignation.SubjectToAMT:
      return "AMT";
    case TaxDesignation.Taxable:
      return "TAX";
    default:
      return designation;
    }
}

const RATING_RANKS = {
  AAA: 12,
  "AA+": 11,
  AA: 10,
  "AA-": 9,
  "A+": 8,
  A: 7,
  "A-": 6,
  "BBB+": 5,
  BBB: 4,
  "BBB-": 3,
  "BB+": 2,
  BB: 1,
  "BB-": 0,
};

function ratingIsHigher(first, second) {
  const firstRank = RATING_RANKS[first];
  const secondRank = RATING_RANKS[second];
  return firstRank > secondRank;
}

export {
  RATING_RANKS,
  ratingIsHigher,
  States,
  SecurityType,
  RatingAssumption,
  ExpandedRatingOptions,
  TaxDesignation,
  PrincipalRate,
  BondSolutions,
  CallPriceDefault,
  CouponSelection,
  SaleMethod,
  getStateAbbreviation
};
